export const SET_PATH_FOR_SIDEBAR = "SET_PATH_FOR_SIDEBAR";
export const CLEAR_PATH_FOR_SIDEBAR = "CLEAR_PATH_FOR_SIDEBAR";

export const SHOW_MIDBAR = "SHOW_MIDBAR";
export const SHOW_SIDEBAR = "SHOW_SIDEBAR";
